<template>
  <TopBarLayout :loading="loading" :data-length="templates.length" title="Todo Templates">
    <template #header>
      <TemplatesHeader @new-template="createModal = true" />
    </template>
    <template #content-data>
      <TodoModal v-model="createModal" from-page="templates" @new-todo="addNewTemplate" />
      <TemplatesContent @loading="loading = $event" />
    </template>
  </TopBarLayout>
</template>

<script>
// Libraries
import { mapMutations, mapState } from 'vuex'
// Mixins
import { registerVuexModule } from '@/mixins/register-vuex-module'
// Components
import TemplatesHeader from './components/TemplatesHeader'
import TemplatesContent from './components/TemplatesContent'
import TodoModal from '@/reusable/TodoModal/TodoModal'
import TopBarLayout from '@/reusable/TopBarLayout/TopBarLayout'

export default {
  components: {
    TemplatesHeader,
    TemplatesContent,
    TodoModal,
    TopBarLayout
  },

  mixins: [
    registerVuexModule('todo-modal', () => require('@/reusable/TodoModal/vuex/TodoModal')),
    registerVuexModule('todo-templates', () => require('./vuex-module'))
  ],

  data: () => ({
    createModal: false,
    loading: false
  }),

  computed: {
    ...mapState('todo-templates', ['templates'])
  },

  methods: {
    ...mapMutations('todo-templates', ['addNewTemplate'])
  }
}
</script>
